export const useCdnUrl = () => {
  const { cdnUrl } = useEnvs()

  const baseImageUrl = `${cdnUrl.value}/ia-images`

  const getIconsUrl = (filename: string) => `${baseImageUrl}/icons/${filename}`
  const getLogosUrl = (filename: string) => `${baseImageUrl}/logos/${filename}`
  const getModalUrl = (filename: string) => `${baseImageUrl}/modal/${filename}`
  const getMetaUrl = (filename: string) => `${baseImageUrl}/meta/${filename}`
  const getUrl = (filename: string) => `${baseImageUrl}/${filename}`
  const getScripts = (filename: string) => `${cdnUrl.value}/scripts/${filename}`

  return {
    getModalUrl,
    getLogosUrl,
    getIconsUrl,
    getMetaUrl,
    getUrl,
    getScripts,
    cdnUrl: cdnUrl.value,
  }
}

export const useIconUrl = (pathname: string) => {
  const { getIconsUrl } = useCdnUrl()
  return computed(() => getIconsUrl(pathname))
}

export const useLogoUrl = (pathname: string) => {
  const { getLogosUrl } = useCdnUrl()
  return computed(() => getLogosUrl(pathname))
}

export const useModalUrl = (pathname: string) => {
  const { getModalUrl } = useCdnUrl()
  return computed(() => getModalUrl(pathname))
}

export const useUrlResource = (pathname: string) => {
  const { getUrl } = useCdnUrl()
  return computed(() => getUrl(pathname))
}
